
import { Button, Grid, Typography } from "@mui/material";
import { IoMdCloudUpload } from "react-icons/io";
import { RiDownloadCloud2Fill } from "react-icons/ri";
import { toast } from "react-toastify";

export type FileUploadSectionProps = {
  titulo: string;
  archivoSeleccionado: File | null;
  setArchivoSeleccionado: (file: File) => void;
  urlArchivoGuardado?: string | null;
  disabledField?: boolean;
  inputId: string
}
export default function FileUploadSection({
  titulo,
  archivoSeleccionado,
  setArchivoSeleccionado,
  urlArchivoGuardado,
  disabledField = false,
  inputId
}: FileUploadSectionProps) {

  return (
    <>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
        {titulo}
      </Typography>
      <Typography variant="caption" color={"textSecondary"} sx={{ mb: 1, display: "block" }}>
        Formatos permitidos: PDF, DOC, DOCX, JPEG, JPG, PNG, XLSX, SVG, TXT y otros formatos de imagen
      </Typography>
      {/*  Archivo ya guardado */}
      {urlArchivoGuardado && !archivoSeleccionado && (
        <Grid item sx={{ mb: 2 }}>
          <Typography variant="body2" color={"success.main"} sx={{ mb: 1 }}>
            Archivo guardado:
          </Typography>
          <a target="_blank" href={urlArchivoGuardado} rel="noreferrer">
            <Button
              variant="text"
              size="small"
              endIcon={<RiDownloadCloud2Fill size={22} />}
              sx={{
                backgroundColor: "#f1f3f4",
                color: "#333",
                fontWeight: 600,
                justifyContent: "space-between",
                "&:hover": { backgroundColor: "#e0e0e0" },
              }}
            >
              {"Ver/Descargar Archivo"}
            </Button>
          </a>
        </Grid>
      )}
      {/*  Mensaje solo lectura */}
      {disabledField && !urlArchivoGuardado && !archivoSeleccionado &&(
        <Typography>
          No hay archivo cargado
        </Typography>
      )}
      {/* Input archivo */}
      {!disabledField && (
        <Grid item mt={1}>
          <input
            type="file"
            id={inputId}
            accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.xlsx,.xls,.svg,.txt,.gif,.bmp,.webp,.tiff"
            style={{ display: "none" }}
            onChange={(e) => {
              if (e.target.files && e.target.files[0]) {
                setArchivoSeleccionado(e.target.files[0]);
                toast.info(`Archivo seleccionado: ${e.target.files[0].name}`)
              }
            }}
          />
          <label htmlFor={inputId}>
            <Button variant="text" component="span" endIcon={< IoMdCloudUpload size={22} />}>
              {archivoSeleccionado ? "Cambiar Archivo" : "Seleccionar Archivo"}
            </Button>
          </label>
          {archivoSeleccionado && (
            <Typography variant="body2" sx={{ mt: 1, color: 'primary.main' }}>
              {`Archivo Seleccionado:${archivoSeleccionado.name}`}
            </Typography>
          )}
        </Grid>

      )}

    </>
  )
} 